import {
  DirectSalesFilteredCampaignsStatusTableResponse,
  DirectSalesStatusOption,
} from 'components/common/types/DirectSalesCampaign.types';
import { DirectSalesStatusLabel } from 'components/pages/Planner/PlannerLineActions/DirectSalesPlannerLineActions/Status/StatusPanel/StatusPanel.types';

export const DIRECT_SALES_DEALS_CAMPAIGN_STATUS_FILTER_OPTIONS: {
  code: DirectSalesFilteredCampaignsStatusTableResponse;
  name: DirectSalesStatusLabel;
}[] = [
  { code: DirectSalesStatusOption.DRAFT, name: DirectSalesStatusLabel.DRAFT },
  { code: DirectSalesStatusOption.MIXED, name: DirectSalesStatusLabel.MIXED },
  { code: DirectSalesStatusOption.PROPOSAL, name: DirectSalesStatusLabel.PROPOSAL },
  { code: DirectSalesStatusOption.OPTION, name: DirectSalesStatusLabel.OPTION },
  { code: DirectSalesStatusOption.CONFIRMED, name: DirectSalesStatusLabel.CONFIRMED },
  { code: DirectSalesStatusOption.LIVE, name: DirectSalesStatusLabel.LIVE },
  { code: DirectSalesStatusOption.CANCELLED, name: DirectSalesStatusLabel.CANCELLED },
  { code: DirectSalesStatusOption.ENDED, name: DirectSalesStatusLabel.ENDED },
];

export const DEFAULT_DIRECT_SALES_DEALS_CAMPAIGN_STATUS_CODES: DirectSalesFilteredCampaignsStatusTableResponse[] =
  DIRECT_SALES_DEALS_CAMPAIGN_STATUS_FILTER_OPTIONS.filter(({ code }) => code !== DirectSalesStatusOption.DRAFT).map(
    ({ code }) => code,
  );
